
import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";


const ScoreStars = ({ score_counts }) => {
    score_counts = score_counts.reverse()
    const [showDetails, setShowDetails] = useState(false);

    const ratingOptions = [
        { value: 1, text: 'مرجوع کامل سفارش بدون دلیل ' },
        { value: 2, text: 'عدم دریافت سفارش در مرحله اول و یا مانده کردن فاکتور ' },
        { value: 3, text: 'دریافت سفارش و پرداخت چک بالاتر از مدت توافق شده ' },
        { value: 4, text: 'دریافت ناقص سفارش و تسویه پای بار توسط چک ثبت شده' },
        { value: 5, text: 'دریافت کامل سفارش و تسویه نقدی پای بار ' },

    ];

    const newRatingOptions = ratingOptions.map(option => option.text);

    return (
        <div className="score-stars-component bg-light rounded mt-3  ">
            <div className="text-start px-2">
                <button
                    className="btn btn-link px-0 text-small-2 text-dark"
                    onClick={() => setShowDetails((prev) => !prev)}
                    style={{textDecoration: "none"}}
                >
                    <span className="me-2 px-2">نمایش جزئیات</span>
                    {showDetails ? <FaChevronUp/> : <FaChevronDown/>}
                </button>
            </div>
            {showDetails && (
                <div className="score-stars-list p-2">
                    {score_counts.map((count, idx) => (
                        <div
                            key={idx}

                            className="d-flex flex-column align-items-end mb-2"
                        >
                            <div className="d-flex align-items-center flex-row-reverse">
            <span className="badge bg-secondary ms-2 ">
               {count}
                {" "}
                نفر
            </span>
                                <div className="stars-group d-flex me-2  ">
                                    {[...Array(5 -idx )].map((_, starIdx) => (
                                        <FaStar
                                            key={starIdx}
                                            color="#ffc107"
                                            style={{marginLeft: "2px"}}
                                        />
                                    ))}
                                </div>
                            </div>

                            {/* این div اکنون در خط دوم و زیر گروه بالا قرار می‌گیرد */}
                            <div className='text-small-2 text-muted mt-1 text-end w-100 mb-4'> {/* کلاس text-end اضافه شد */}
                                {
                                    newRatingOptions[4 - idx]
                                }
                            </div>
                        </div>
                    ))}

                </div>
            )}
        </div>
    );
}

export default ScoreStars;